
const apiHost = (
  process.env.NODE_ENV === 'development'
    ? 'https://online-express.ru/api/'
    : 'https://online-express.ru/api/' // location.origin
)

export default apiHost